import apiClient from "../../../utilities/apiClient";
import { ROLES, ADMIN_ROLES } from "../../../utilities/roles";

import LocalStorage, { SESSION_KEY } from "../../../utilities/localStorage";

export const get_vendors = (payload) => {
  return apiClient.get(`${apiClient.Urls.vendors_list}`, payload, true);
};

export const approve_pr = (payload) => {
  var user = LocalStorage.getItem(SESSION_KEY);
  const roles = user.roles;
  const role = roles[0];
  return apiClient.patch(
    role !== ROLES.OFFICER
      ? `${apiClient.Urls.pr_approve_sa}/${payload.pr_id}`
      : `${apiClient.Urls.pr_approve}/${payload.pr_id}`,
    payload,
    true,
  );
};

export const approve_item = (payload) => {
  var user = LocalStorage.getItem(SESSION_KEY);
  const roles = user.roles;
  const role = roles[0];
  return apiClient.patch(
    role !== ROLES.OFFICER
      ? `${apiClient.Urls.item_approve_sa}`
      : `${apiClient.Urls.item_approve}`,
    payload,
    true,
  );
};

export const push_pr_to_pg = (payload) => {
  var user = LocalStorage.getItem(SESSION_KEY);
  const roles = user.roles;
  const role = roles[0];
  return apiClient.post(
    role === ROLES.OFFICER
      ? `${apiClient.Urls.officer_push_pr_to_pg}`
      : `${apiClient.Urls.admin_push_pr_to_pg}`,
    payload,
    true,
  );
};

export const get_materials = (payload) => {
  var user = LocalStorage.getItem(SESSION_KEY);
  var roles = user.roles;
  var role = roles[0];
  return apiClient.get(
    role !== ROLES.OFFICER
      ? `${apiClient.Urls.materials_list_sa}?item_name=${payload?.search_key}`
      : payload?.search_by === "item_code"
      ? `${apiClient.Urls.materials_list_by_code}?${payload?.search_by}=${payload?.search_key}`
      : `${apiClient.Urls.materials_list}?${payload?.search_by}=${payload?.search_key}`,
    "",
    true,
  );
};

export const get_vendor_emails = (payload) => {
  return apiClient.get(
    `${apiClient.Urls.vendors_list}?vendor_id=${payload}`,
    "",
    true,
  );
};

export const prs = (payload) => {
  var user = LocalStorage.getItem(SESSION_KEY);
  const roles = user.roles;
  const role = roles[0];
  return apiClient.post(
    role === ROLES.OFFICER
      ? `${apiClient.Urls.officer_prs}`
      : `${apiClient.Urls.admin_prs}`,
    payload,
    true,
    "file",
  );
};
export const EditPrs = (payload) => {
  var user = LocalStorage.getItem(SESSION_KEY);
  const roles = user.roles;
  const role = roles[0];
  return apiClient.patch(
    role === ROLES.OFFICER
      ? `${apiClient.Urls.officer_prs}`
      : `${apiClient.Urls.admin_prs}`,
    payload,
    true,
    "file",
  );
};

export const view_AdminPrDetails = (payload) => {
  var user = LocalStorage.getItem(SESSION_KEY);
  const roles = user.roles;
  const role = roles[0];
  return apiClient.get(
    role !== ROLES.OFFICER
      ? `${apiClient.Urls.view_admin_pr_details_sa}/${payload}`
      : `${apiClient.Urls.view_admin_pr_details}/${payload}`,
    "",
    true,
  );
};

export const view_AdminApprovedItemsPrDetails = (payload) => {
  var user = LocalStorage.getItem(SESSION_KEY);
  const roles = user.roles;
  const role = roles[0];
  return apiClient.get(
    role === ROLES.OFFICER
      ? `${apiClient.Urls.view_officer_approved_items_pr_details}/${payload}`
      : `${apiClient.Urls.view_admin_approved_items_pr_details}/${payload}`,
    "",
    true,
  );
};

export const view_AdminItemDetails = (payload) => {
  var user = LocalStorage.getItem(SESSION_KEY);
  const roles = user.roles;
  const role = roles[0];
  return apiClient.get(
    role !== ROLES.OFFICER
      ? `${apiClient.Urls.view_admin_item_details_sa}/${payload}`
      : `${apiClient.Urls.view_admin_item_details}/${payload}`,
    "",
    true,
  );
};

export const get_prs = (status, filter, page, per_page, search) => {
  var user = LocalStorage.getItem(SESSION_KEY);
  const roles = user.roles;
  const role = roles[0];
  return apiClient.get(
    role !== ROLES.OFFICER
      ? `${
          apiClient.Urls.prs_list_sa
        }?filter=${filter}&status=${status}&page=${page}&per_page=${per_page}&search=${
          search || ""
        }`
      : `${
          apiClient.Urls.prs_list
        }?filter=${filter}&status=${status}&page=${page}&per_page=${per_page}&search=${
          search || ""
        }`,
    "",
    true
  );
};

export const get_all_prs = () => {
  return apiClient.get(apiClient.Urls.all_prs, "", true);
};

export const copy_pr = (payload) => {
  var user = LocalStorage.getItem(SESSION_KEY);
  const roles = user.roles;
  const role = roles[0];
  return apiClient.post(
    role === ROLES.OFFICER
      ? `${apiClient.Urls.officer_copy_pr}`
      : `${apiClient.Urls.admin_copy_pr}`,
    payload,
    true,
  );
};
export const download_pr_excel_data = (payload) => {
  var user = LocalStorage.getItem(SESSION_KEY);
  const roles = user.roles;
  const role = roles[0];
  return apiClient.post(
    role === ROLES.OFFICER
      ? `${apiClient.Urls.officer_download_pr_excel}`
      : `${apiClient.Urls.download_pr_excel}`,
    payload,
    true,
    "blob",
  );
};

export const add_excel_data = (payload) => {
  return apiClient.post(`${apiClient.Urls.add_excel_prs}`, payload, true);
};

export const PR_preview = (payload) => {
  return apiClient.get(`${apiClient.Urls.prDownalod}/${payload}`, "", true);
};
export const get_excelToPrItemDetails = (payload) => {
  return apiClient.post(
    `${apiClient.Urls.getExcelToPrItemDetails}`,
    payload,
    true,
    "file",
  );
};
